import FilterButtonGroup from "components/FilterButtonGroup";
import { FilterZipInput } from "components/FilterZipInput";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const AfstandFilter = ({ condensed }) => {
    const filterOptions = useFilter("afstand");
    const [postcodeValue, , onPostcodeChange] = useField("postcode");
    const [afstandValue, , onAfstandChange] = useField("afstand");

    const handleZipSelect = (_, value) => {
        onPostcodeChange([value]);
        onAfstandChange([100]);
    };
    const afstandOptions =
        filterOptions.map((option) => ({
            id: option,
            displayName: `${option} km`,
            naam: `${option} km`
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterZipInput
                filterId="filter-kilometerstand-min"
                value={postcodeValue || []}
                handleChange={handleZipSelect}
                datalayerKey="regio.postcode"
                helpText="Postcode"
                autoComplete="do-not-autofill"
                ariaLabel="Postcode"
                maxLength="7"
            />
            <FilterButtonGroup
                filterId="filter-afstand-radius"
                options={afstandOptions}
                value={afstandValue ? afstandValue.map((i) => Number(i)) : []}
                handleChange={(_, value) => onAfstandChange(value)}
                datalayerKey="regio.afstand"
                columns={condensed ? 2 : 10}
                isSingle
                isDisabled={!postcodeValue[0]}
            />
        </Grid>
    );
};
